export default {
  type: '',
  props: {},
}
